import loadLightbox, { open } from "../Lightbox/src";

interface Partner {
  taglineLogo?: null | string;
  title?: string;
  logoUrl?: string;
  mainBody?: string;
  link?: string;
}
interface lightboxProps {
  title: string;
  Partners: Partner[];
}

export default ({
  data = [],
  elClassName
}: {
  data: lightboxProps[];
  elClassName: string;
}) => {
  const formattedData = data
    .map(({ Partners }) => Partners)
    .reduce((a, b) => a.concat(b), []);
  let elements: HTMLElement[] | null = Array.from(
    document.querySelectorAll(
      `.${elClassName} .commercial-partners__sponsors-image`
    )
  );

  const links: HTMLElement[] | null = Array.from(
    document.querySelectorAll(
      `.${elClassName} .commercial-partners__sponsors-link`
    )
  );

  loadLightbox({
    elClassName: "lightbox-company",
    otherClasses: ["lightbox-commercial-partners"]
  });

  if (elements !== null && links !== null) {
    if (links.length) {
      links.map((el: HTMLElement, key: number) => {
        el.addEventListener(
          "click",
          open.bind(null, {
            func: () => updateLightBox(formattedData[key]),
            className: "lightbox-company"
          })
        );
      });
    }
    elements.map((el: HTMLElement, key: number) => {
      el.addEventListener(
        "click",
        open.bind(null, {
          func: () => updateLightBox(formattedData[key]),
          className: "lightbox-company"
        })
      );
    });
  }
};

const updateLightBox = ({ title, logoUrl, mainBody, link }: Partner) => {
  const lb = document.querySelector(".lightbox-dialogue");

  if (lb !== null) {
    lb.innerHTML = `
      <div class="lightbox-content">
        <div class="lightbox-img">
          <a
            onclick="gtag('event', 'sponsor_click', { 'event_category': 'Commercial Sponsors', 'event_label': '${title}' });"
            href="${link}"
            target="_blank"
          >
            <img src="${logoUrl}">
          </a>
        </div>
        <div class="lightbox-description">
          <strong>${title}</strong>
          <div>${mainBody}</div>
        </div>
      </div>
    `;
  }
};
